module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av419-a097d03b87a6b21db8a72eaf4dfa6f87.jpg";